import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BaseComponent } from './../moov-common/base/base.component';
import { Router } from '@angular/router';
import { NAVIGATION_ROUTES } from '../navigation-routes.const';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-navigation-bar',
  templateUrl: './navigation-bar.component.html',
  styleUrls: ['./navigation-bar.component.scss'],
})
export class NavigationBarComponent extends BaseComponent implements OnInit {
  isLoggedIn: boolean = false;

  @Output() logoutEvent = new EventEmitter<void>();
  @Output() toggleMenuEvent = new EventEmitter<boolean>();

  constructor(public dialog: MatDialog, public router: Router) {
    super();
  }

  get isFirstTime(): boolean {
    return this.router.url === '/' + NAVIGATION_ROUTES.app.firstTimeLogin;
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.isLoggedIn = this.user ? true : false;
  }

  logoutClicked() {
    this.logoutEvent.emit();
  }

  isLoginPage() {
    return this.router.url === '/' + NAVIGATION_ROUTES.login;
  }

  isTokenLoginPage() {
    return this.router.url === '/' + NAVIGATION_ROUTES.tokenLogin;
  }

  toggleMenu() {
    this.toggleMenuEvent.emit(true);
  }

}
